import { useEffect, useRef, useState } from "react";
import Steps from "../../../components/steps/Steps";
import TimePickerInput from "../../../components/timePickerInput/TimePickerInput";
import DatePickerInput from "../../../components/datePickerInput/DatePickerInput";
import {
  DropDown,
  InputField,
  PhoneInput,
  SubmitButton,
  TextComponent,
  TextareaField,
} from "../../../components";
import styles from "./EditEvent.module.css";
import RoomImage from "../../../assets/RoomImage.png";
import { Col, Row } from "antd";
import { useLocation, useNavigate } from "react-router-dom";
import {
  CalendarIcon,
  ClockIcon,
  LocIcon,
} from "../../../components/icons/Icons";
import Dropdown from "../../../components/dropdowns/Dropdown";
import { useDispatch, useSelector } from "react-redux";
import { AuthMiddleware } from "../../../Store/Middlewares/AuthMiddleware";
import { showAlert } from "../../../Store/Actions/GeneralActions";
import moment from "moment";
import dayjs from "dayjs";
import { EventMiddleware } from "../../../Store/Middlewares/EventMiddleware";
import AutoCompleteInput from "../../../components/auntoCompleteInput/AutoCompleteInput";
import { CurrentLocation } from "../../../config/CurrentLocation";

const FirstStep = ({ setCurrentStep }) => {
  return (
    <>
      <Row className={styles.row} justify={"space-between"} gutter={16}>
        <Col xs={24} md={14} lg={16}>
          <DropDown
            label={"Event Category"}
            options={[
              { value: "Wedding Party", option: "Wedding Party" },
              { value: "Anniversary", option: "Anniversary" },
              { value: "Birthday", option: "Birthday" },
            ]}
          />
          <InputField label="Event Name" />
          <TextareaField label="Description" />
          <InputField label="No Of Guests" type="number" />
        </Col>
        <Col xs={24} md={10} lg={8}>
          <img className={styles.img} src={RoomImage} />
        </Col>
      </Row>
      <Row>
        <Col xs={24} md={10} lg={8}>
          <SubmitButton
            title={"Next"}
            btnClass={styles.solidBtn}
            onClick={() => setCurrentStep((prev) => prev + 1)}
          />
        </Col>
      </Row>
    </>
  );
};

const SecondStep = () => {
  const navigate = useNavigate();
  return (
    <>
      <Row className={styles.row} justify={"space-between"} gutter={16}>
        <Col xs={24} md={12}>
          <DatePickerInput label="Date" icon={<CalendarIcon size={25} />} />
        </Col>
        <Col xs={24} md={12}>
          <DropDown
            label="Status"
            options={[
              { value: "Active", option: "Active" },
              { value: "Pending", option: "Pending" },
            ]}
          />
        </Col>
        <Col xs={24} md={12}>
          <TimePickerInput label="Start Time" icon={<ClockIcon size={25} />} />
        </Col>
        <Col xs={24} md={12}>
          <TimePickerInput label="End Time" icon={<ClockIcon size={25} />} />
        </Col>
        <Col xs={24} md={12}>
          <InputField label="Address" rightIcon={<LocIcon size={25} />} />
        </Col>
      </Row>
      <Row>
        <Col xs={24} md={10} lg={8}>
          <SubmitButton
            title={"Save"}
            btnClass={styles.solidBtn}
            onClick={() => navigate(-1)}
          />
        </Col>
      </Row>
    </>
  );
};

const stepLinks = [
  {
    id: 1,
  },
  {
    id: 2,
  },
  {
    id: 3,
  },
];

const EditEvent = () => {
  const EventCategory = useSelector(
    (state) => state?.GeneralReducer?.GeneralTypes
  );
  const event = useSelector((state) => state.EventReducer.EventDetails);
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const [eventCategory, setEventCategory] = useState();
  console.log('event', event);

  const [currentStep, setCurrentStep] = useState([]);
  const [eventName, setEventName] = useState(event?.name);
  const [currentLocation, setCurrentLocation] = useState();
  const [address, setAddress] = useState(event?.address);
  const [receptionCurrLoc, setReceptionCurrLoc] = useState();
  const [receptionAddress, setReceptionAdress] = useState(event?.reception_address);
  const [description, setDescription] = useState(event?.description);
  const [guest, setGuest] = useState(event?.no_of_guest);
  const [date, setDate] = useState(dayjs(event?.date));
  const [startTime, setStartTime] = useState(dayjs(event?.start_time));
  const [endTime, setEndTime] = useState(dayjs(event?.end_time));
  const [receptionStartTime, setReceptionStartTime] = useState(event?.reception_start_time ? dayjs(event?.reception_start_time): null);
  const [receptionEndTime, setReceptionEndTime] = useState(event?.reception_end_time ? dayjs(event?.reception_end_time) : null);
  const [eventStatus, setEventStatus] = useState(event?.status);
  const [profileImg, setProfileImg] = useState();
  const [brideImg, setBrideImg] = useState();
  const [brideEmail, setBrideEmail] = useState(event?.bride?.email);
  const [brideContactNumber, setBrideContactNumber] = useState(event?.bride?.contact_no);
  const [brideFirstName, setBrideFirstName] = useState(event?.bride?.first_name);
  const [brideLastName, setBrideLastName] = useState(event?.bride?.last_name);
  const [groomImg, setGroomImg] = useState();
  const [groomEmail, setGroomEmail] = useState(event?.groom?.email);
  const [groomContactNumber, setGroomContactNumber] = useState(event?.groom?.contact_no);
  const [groomFirstName, setGroomFirstName] = useState(event?.groom?.first_name);
  const [groomLastName, setGroomLastName] = useState(event?.groom?.last_name);
  const [lat, setLat] = useState(event?.lat);
  const [lng, setLng] = useState(event?.lng);
  const [receptionLat, setReceptionLat] = useState(event?.reception_latitude);
  const [receptionLng, setReceptionLng] = useState(event?.reception_longitude);
  const [latlng, setlatlng] = useState();
  console.log('profileImg============>>>>>>', event);
  console.log('address============>>>>>>', address);
  const hiddenFileInputProfile = useRef();
  const handleClickProfile = (event) => {
    hiddenFileInputProfile.current.click();
  };

  const hiddenFileInputBride = useRef();
  const handleClickBride = (event) => {
    hiddenFileInputBride.current.click();
  };

  const hiddenFileInputGroom = useRef();
  const handleClickGroom = (event) => {
    hiddenFileInputGroom.current.click();
  };

  useEffect(() => {
    dispatch(CurrentLocation.getLiveLocation())
    .then((res) => {
      setlatlng(res);
    })
    .catch((err) => {
      console.log(err);
    });
    dispatch(AuthMiddleware.GeneralType());
    setCurrentStep(stepLinks[0].id);
    const category = EventCategory?.eventcategory?.find(
      (i) => i.id === event?.category?.id
    );
    const obj = { id: category?.id, val: category?.name };
    setEventCategory(obj);
  }, []);

  function handleNextProfile() {
    if ( eventCategory && eventName && description && guest) {
      setCurrentStep((prev) => prev + 1);
    } else {
      dispatch(
        showAlert({ type: "Error", message: "All fields are mandatory!" })
      );
    }
  }

  // function handleNextDetails() {
  //   if (date && eventStatus && endTime && startTime && address) {
  //     setCurrentStep((prev) => prev + 1);
  //   } else {
  //     dispatch(
  //       showAlert({ type: "Error", message: "All fields are mandatory!" })
  //     );
  //   }
  // }
  function handleNextDetails() {
    if (
      moment(startTime?.$d).format("HH:mm") >
      moment(endTime?.$d).format("HH:mm")
    ){
      dispatch(
        showAlert({
          type: "Error",
          message: "Start time should be less than End time",
        })
      );
    }else if (
      moment(receptionStartTime?.$d).format("HH:mm") >
      moment(receptionEndTime?.$d).format("HH:mm")
    ) {
      dispatch(
        showAlert({
          type: "Error",
          message:
            "Reception Start time should be less than Reception End time",
        })
      );
    }
      else if (
        date &&
        eventStatus &&
        endTime &&
        startTime &&
        address &&
        receptionEndTime &&
        receptionStartTime &&
        receptionAddress
      ) {
        setCurrentStep((prev) => prev + 1);
      }  else {
        dispatch(
          showAlert({ type: "Error", message: "All fields are mandatory!" })
        );
      }
  }

  const onPressEdit = () => {
    let userData = {
      id: event?.id,
      eventImage: profileImg,
      EventName: eventName,
      SelectedEventCategoryID: eventCategory?.id,
      Description: description,
      date: moment(date?.$d).format("YYYY-MM-DD"),
      startTime: moment(startTime?.$d).format("HH:mm"),
      endTime: moment(endTime?.$d).format("HH:mm"),
      address,
      lat: currentLocation?.lat ? currentLocation?.lat : lat ,
      lng: currentLocation?.lng ? currentLocation?.lng : lng,
      guest,
      receptionAddress,
      receptionLat: receptionCurrLoc?.lat ? receptionCurrLoc?.lat : receptionLat,
      receptionLng: receptionCurrLoc?.lng ? receptionCurrLoc?.lng : receptionLng,
      receptionStartTime: moment(receptionStartTime?.$d).format("HH:mm"),
      receptionEndTime: moment(receptionEndTime?.$d).format("HH:mm"),
      SelectedStatus: eventStatus,
      brideImage: brideImg,
      brideFName: brideFirstName,
      brideLName: brideLastName,
      brideEmail: brideEmail,
      brideContactNumber: brideContactNumber,
      groomImage: groomImg,
      groomFName: groomFirstName,
      groomLName: groomLastName,
      groomEmail: groomEmail,
      groomContactNumber: groomContactNumber,
    };
    if (!brideImg && !event?.bride?.image) {
      dispatch(
        showAlert({
          title: "Create Event",
          message: "Add bride image.",
          type: "Error",
          status: 400,
        })
      );
      return;
    } else if (
      !brideFirstName ||
      !brideLastName ||
      !brideEmail ||
      !brideContactNumber
    ) {
      dispatch(
        showAlert({
          title: "Create Event",
          message: "All fields are mandatory.",
          type: "Error",
          status: 400,
        })
      );
      return;
    } else if (
      /^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,3})+$/.test(brideEmail) == false
    ) {
      dispatch(
        showAlert({
          title: "Invalid Email!",
          message:
            "Please enter a valid email address of bride (e.g., example@example.com)",
        })
      );
      return;
    } else if (!groomImg && !event?.groom?.image) {
      dispatch(
        showAlert({
          title: "Create Event",
          message: "Add groom image.",
          type: "Error",
          status: 400,
        })
      );
      return;
    } else if (
      !groomFirstName ||
      !groomLastName ||
      !groomEmail ||
      !groomContactNumber
    ) {
      dispatch(
        showAlert({
          title: "Create Event",
          message: "All fields are mandatory.",
          type: "Error",
          status: 400,
        })
      );
      return;
    } else if (
      /^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,3})+$/.test(groomEmail) == false
    ) {
      dispatch(
        showAlert({
          title: "Invalid Email!",
          message:
            "Please enter a valid email address of groom (e.g., example@example.com)",
        })
      );
      return;
    } else {
      dispatch(EventMiddleware.editEvent(userData))
        .then(() => {
          navigate("/events");
        })
        .catch((err) => console.log(err));
    }
  };

  console.log(event, eventCategory);

  return (
    <div>
      <Steps
        stepLinks={stepLinks}
        currentStep={currentStep}
        setCurrentStep={setCurrentStep}
      />

      {currentStep == 1 ? (
        <>
          <Row className={styles.row} justify={"space-between"} gutter={16}>
            <Col xs={24} md={14} lg={16}>
              <Dropdown
                label={"Event Category"}
                onChange={(e) => setEventCategory(e)}
                object={EventCategory?.eventcategory}
                selectedValue={eventCategory?.val}
              />
              <InputField
                label="Event Name"
                value={eventName}
                onChange={(e) => setEventName(e.target.value)}
              />
              <TextareaField
                label="Description"
                value={description}
                onChange={(e) => setDescription(e.target.value)}
              />
              <InputField
                label="No Of Guests"
                type="number"
                value={guest}
                onChange={(e) => setGuest(e.target.value)}
              />
            </Col>
            <Col xs={24} md={10} lg={8}>
              <div onClick={handleClickProfile}>
                <img
                  className={styles.img}
                  src={
                    profileImg ?  URL.createObjectURL(profileImg) : event?.image
                  }
                />
                <input
                  type="file"
                  accept="image/*"
                  onChange={(e) => setProfileImg(e.target.files[0])}
                  ref={hiddenFileInputProfile}
                  style={{ display: "none" }}
                />
              </div>
            </Col>
          </Row>
          <Row>
            <Col xs={24} md={10} lg={8}>
              <SubmitButton
                title={"Next"}
                btnClass={styles.solidBtn}
                onClick={handleNextProfile}
              />
            </Col>
          </Row>
        </>
      ) : currentStep == 2 ? (
        <>
          <Row className={styles.row} justify={"space-between"} gutter={16}>
            <Col xs={24} md={12}>
              <DatePickerInput
                label="Date"
                icon={<CalendarIcon size={25} />}
                value={date}
                onChange={(e) => setDate(e)}
              />
            </Col>
            <Col xs={24} md={12}>
              <Dropdown
                label="Status"
                options={[
                  { value: "Active", option: "Active" },
                  { value: "Pending", option: "Pending" },
                ]}
                onChange={(e) => setEventStatus(e)}
                selectedValue={eventStatus}
              />
            </Col>
            <Col xs={24} md={12}>
              <TimePickerInput
                label="Start Time"
                icon={<ClockIcon size={25} />}
                value={startTime}
                onChange={(e) => setStartTime(e)}
              />
            </Col>
            <Col xs={24} md={12}>
              <TimePickerInput
                label="End Time"
                icon={<ClockIcon size={25} />}
                value={endTime}
                onChange={(e) => setEndTime(e)}
              />
            </Col>
            <Col xs={24} md={12}>
            <AutoCompleteInput
          label={"Address"}
          placeholder={address}
          address={currentLocation?.adress}
          onSelectPlace={(place) => {
            let currentLocation = {
              lat: place?.geometry?.location?.lat(),
              lng: place?.geometry?.location?.lng(),
              address: place?.formatted_address,
            };
            setAddress(currentLocation?.address)
            setCurrentLocation(currentLocation);
          }}
          />
              {/* <InputField
                label="Address"
                rightIcon={<LocIcon size={25} />}
                value={address}
                onChange={(e) => setAddress(e.target.value)}
              /> */}
            </Col>
            <Col xs={24} md={12}>
              <AutoCompleteInput
                label={"Reception Location"}
                placeholder={receptionAddress}
                address={receptionCurrLoc?.adress}
                onSelectPlace={(place) => {
                  let receptionCurrLoc = {
                    lat: place?.geometry?.location?.lat(),
                    lng: place?.geometry?.location?.lng(),
                    address: place?.formatted_address,
                  };
                  setReceptionAdress(receptionCurrLoc?.address);
                  setReceptionCurrLoc(receptionCurrLoc);
                }}
              />
            </Col>

            <Col xs={24} md={12}>
              <TimePickerInput
                label="Reception Start Time"
                icon={<ClockIcon size={25} />}
                value={receptionStartTime}
                onChange={(e) => setReceptionStartTime(e)}
              />
            </Col>
            <Col xs={24} md={12}>
              <TimePickerInput
                label="Reception End Time"
                icon={<ClockIcon size={25} />}
                value={receptionEndTime}
                onChange={(e) => setReceptionEndTime(e)}
              />
            </Col>
          </Row>
          <Row gutter={[8, 12]}>
            <Col xs={24} sm={12} md={10} lg={8}>
              <SubmitButton
                title={"Back"}
                btnClass={styles.solidBtn}
                onClick={() => setCurrentStep((prev) => prev - 1)}
              />
            </Col>
            <Col xs={24} sm={12} md={10} lg={8}>
              <SubmitButton
                title={"Next"}
                btnClass={styles.solidBtn}
                onClick={handleNextDetails}
              />
            </Col>
          </Row>
        </>
      ) : currentStep === 3 ? (
        <>
          <TextComponent textClass={styles.heading}>
            Bride Details
          </TextComponent>
          <Row className={styles.row} justify={"space-between"} gutter={16}>
            <Col xs={24} md={14} lg={16}>
              <Row gutter={[16, 0]}>
                <Col xs={24} md={12}>
                  <InputField
                    label="First Name"
                    value={brideFirstName}
                    onChange={(e) => setBrideFirstName(e.target.value)}
                  />
                </Col>
                <Col xs={24} md={12}>
                  <InputField
                    label="Last Name"
                    value={brideLastName}
                    onChange={(e) => setBrideLastName(e.target.value)}
                  />
                </Col>
              </Row>
              <InputField
                label="Email"
                value={brideEmail}
                type="email"
                onChange={(e) => setBrideEmail(e.target.value)}
              />
              <PhoneInput
                className={styles.phoneInput}
                value={brideContactNumber}
                onChange={setBrideContactNumber}
                label={"Contact Number"}
              />
            </Col>
            <Col xs={24} md={10} lg={8}>
              <div onClick={handleClickBride}>
                <img
                  className={styles.img}
                  src={
                    brideImg ? 
                     URL.createObjectURL(brideImg) : event?.bride?.image

                      
                  }
                />
                <input
                  type="file"
                  accept="image/*"
                  onChange={(e) => setBrideImg(e.target.files[0])}
                  ref={hiddenFileInputBride}
                  style={{ display: "none" }}
                />
              </div>
            </Col>
          </Row>
          {/* <Row>
            <Col xs={24} md={10} lg={8}>
              <SubmitButton
                title={"Create"}
                btnClass={styles.solidBtn}
                // onClick={() => setCurrentStep((prev) => prev + 1)}
              />
            </Col>
          </Row> */}
          <TextComponent textClass={styles.heading}>
            Groom Details
          </TextComponent>
          <Row className={styles.row} justify={"space-between"} gutter={16}>
            <Col xs={24} md={14} lg={16}>
              <Row gutter={[16, 0]}>
                <Col xs={24} md={12}>
                  <InputField
                    label="First Name"
                    value={groomFirstName}
                    onChange={(e) => setGroomFirstName(e.target.value)}
                  />
                </Col>
                <Col xs={24} md={12}>
                  <InputField
                    label="Last Name"
                    value={groomLastName}
                    onChange={(e) => setGroomLastName(e.target.value)}
                  />
                </Col>
              </Row>
              <InputField
                label="Email"
                value={groomEmail}
                type="email"
                onChange={(e) => setGroomEmail(e.target.value)}
              />
              <PhoneInput
                className={styles.phoneInput}
                value={groomContactNumber}
                onChange={setGroomContactNumber}
                label={"Contact Number"}
              />
            </Col>
            <Col xs={24} md={10} lg={8}>
              <div onClick={handleClickGroom}>
                <img
                  className={styles.img}
                  src={
                    groomImg ?
                    URL.createObjectURL(groomImg) :event?.groom?.image
                     
                  }
                />
                <input
                  type="file"
                  accept="image/*"
                  onChange={(e) => setGroomImg(e.target.files[0])}
                  ref={hiddenFileInputGroom}
                  style={{ display: "none" }}
                />
              </div>
            </Col>
          </Row>
          <Row gutter={[8, 12]}>
            <Col xs={24} sm={12} md={10} lg={8}>
              <SubmitButton
                title={"Back"}
                btnClass={styles.solidBtn}
                onClick={() => setCurrentStep((prev) => prev - 1)}
              />
            </Col>
            <Col xs={24} sm={12} md={10} lg={8}>
              <SubmitButton
                title={"Save"}
                btnClass={styles.solidBtn}
                onClick={onPressEdit}
              />
            </Col>
          </Row>
        </>
      ) : null}
    </div>
  );
};

export default EditEvent;
